// extracted by mini-css-extract-plugin
module.exports = {"wp-block-styles":"WordPressBlockStyleVer_5_8_1_wp-block-styles___dQ7C"};